





























































import { Component, Watch } from 'vue-property-decorator';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { OpportunityDetailsModule } from '@/store/modules/opportunityDetails';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import OpportunityStage from '@/models/Opportunities/OpportunityStage';

@Component({ name: 'OpportunityStageSetLost' })
export default class extends GiganautVueDialog {
  // Lost reason is an agency-configurable lookup (managed in Settings) and is
  // required when marking Lost — the agency must have at least one configured.
  lostReasonId: string | null = null;
  lostNotes = '';

  get opportunity() { return OpportunityDetailsModule.opportunity; }
  get saving() { return OpportunityDetailsModule.saving; }

  get lostReasonOptions() { return AgencySettingsModule.opportunityLostReasons; }

  @Watch('dialog')
  onDialogChanged(val: boolean) {
    if (val && this.opportunity) {
      this.lostReasonId = this.opportunity.lostReasonId || null;
      this.lostNotes = this.opportunity.lostReasonNotes || '';
      if (AgencySettingsModule.opportunityLostReasons.length === 0) {
        AgencySettingsModule.getOpportunityLostReasons();
      }
    }
  }

  async save() {
    if (!(this.$refs.form as any).validate() || !this.opportunity) return;
    await OpportunityDetailsModule.setStage({
      id: this.opportunity.id,
      stage: OpportunityStage.Lost,
      lostReasonId: this.lostReasonId,
      lostReasonNotes: this.lostNotes,
      updatedAt: this.opportunity.updatedAt,
    });
    this.dialog = false;
    this.$emit('closeMenu');
  }
}
